import { WebsiteElement } from '@/interfaces/element.interface';
import { ApiQueryParams, apiRequest } from '../Api';

export interface CreateWebsiteElementResponse {
  success: boolean;
  message: string;
  data: { id: string };
  execution_time: number;
  cached: boolean;
  timestamp: string;
}

export const createWebsiteElement = (
  params: ApiQueryParams,
  data: WebsiteElement
) =>
  apiRequest<WebsiteElement, CreateWebsiteElementResponse>({
    url: '/entities/create',
    scope: 'element',
    method: 'POST',
    params,
    data: { data },
  });